import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import * as FileSaver from 'file-saver';
import {SubSink} from '@Common/core/utils/subsink';
import {finalize} from 'rxjs/operators';
import {PubSubService} from '@Common/core/services';
import {MatDialog} from '@angular/material/dialog';
import {DomSanitizer} from '@angular/platform-browser';
import {DisclaimerModaleFileModel} from './disclaimer-modale-file.model';
import {AttachmentService} from "@Common/widgets/general/attachments";
import {AttachmentModel} from "@Common/widgets/general/attachments/interfaces/attachment.model";


@Component({
  selector: 'app-download-files',
  templateUrl: './download-files.component.html',
  styleUrls: ['./download-files.component.scss']
})
export class DownloadFilesComponent implements OnInit, OnDestroy {
  @Input()
  file: AttachmentModel;
  /**
   * Y a-t-il une modale d'information à valider avant téléchargement du fichier ?
   */
  @Input() disclaimer: DisclaimerModaleFileModel = null;

  @Input()
  type: string;
  @Input() tooltip: string;

  subSink = new SubSink();

  constructor(private pubSubSvc: PubSubService,
              private pieceJointeDownload: AttachmentService) { }

  ngOnInit() {
  }

  private _downloadFile() {
    this.pubSubSvc.publish('loading', true);

    this.subSink.sink = this.pieceJointeDownload.download(this.file)
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe(data => FileSaver.saveAs(data, this.file.filename_origin));
  }
  downloadPieceJointe() {
      this._downloadFile();
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
